export default __webpack_public_path__ + "static/workshop-66eefc7f2691c46f9c7dc81a9546af18.jpg";